import store from "../../../store";
import { Redirect, Route } from "react-router-dom";
import { hasRole, hasAnyRole } from "../../../utils";
import { AirportGreeterRole, PricingManagerRole } from "../../../utils/userAccess";

export function PrivateRoute({ children, ...rest }) {
  //console.log("Children: ", children)
  //console.log("Children: ", rest)
  const state = store.getState();
  const isAuth = state.user.token;

  //TODO: enhance route with roles
  const selectedWebsite = state?.user?.websites ? state?.user?.websites.find(w => w.isDefault) : null;
  const isAdminOrDispatcher = hasAnyRole(selectedWebsite, ["Administrator", "Dispatcher"]);
  const isClient = hasRole(selectedWebsite, "Client");
  const isDriver = hasRole(selectedWebsite, "Driver");
  const isCarOwner = hasRole(selectedWebsite, "CarOwner");
  const isAirportGreeter = hasRole(selectedWebsite, AirportGreeterRole);
  const isFleetManager = hasRole(selectedWebsite, "Fleet Manager");
  const isSupportOrAgent = hasAnyRole(selectedWebsite, ["Support Operator", "Agent"]);
  const isPricingManager = hasRole(selectedWebsite, PricingManagerRole);

  if (selectedWebsite != null && !isAdminOrDispatcher && !isClient && !isDriver && !isCarOwner && !isAirportGreeter && !isFleetManager && !isSupportOrAgent && !isPricingManager) {
    console.log("Redirect to login: ");
    return <Redirect
      to={{ pathname: "/login" }}
    />
  }

  if (!isAuth) {
    return <Redirect
      to={{
        pathname: "/login",
        //state: { from: location }
      }}
    />
  }
  return (
    <Route {...rest} />
  );
}